import type {
  AuthStatus,
  ChangePasswordInput,
  LoginInput,
  LoginResponse,
  PublicUser,
  RegisterInput,
  RegisterResponse,
  SessionInfo,
  SetupInput,
  UpdateProfileInput,
  VerifyEmailInput,
} from "@codvero/shared";
import { api, del, get, post } from "./client.ts";

export const authApi = {
  status: () => get<AuthStatus>("/api/auth/status"),
  setup: (input: SetupInput) => post<{ user: PublicUser }>("/api/auth/setup", input),
  register: (input: RegisterInput) => post<RegisterResponse>("/api/auth/register", input),
  resend: (pendingUserId: string) => post<RegisterResponse>("/api/auth/register/resend", { pendingUserId }),
  verify: (input: VerifyEmailInput) => post<{ user: PublicUser }>("/api/auth/register/verify", input),
  login: (input: LoginInput) => post<LoginResponse>("/api/auth/login", input),
  logout: () => post<void>("/api/auth/logout"),
  sessions: () => get<SessionInfo[]>("/api/auth/sessions"),
  revokeSession: (id: string) => del(`/api/auth/sessions/${id}`),
  updateProfile: (input: UpdateProfileInput) => api<{ user: PublicUser }>("/api/auth/profile", { method: "PATCH", json: input }),
  changePassword: (input: ChangePasswordInput) => post<void>("/api/auth/password", input),
  totpBegin: () => post<{ secret: string; otpauthUrl: string }>("/api/auth/totp/begin"),
  totpConfirm: (code: string) => post<void>("/api/auth/totp/confirm", { code }),
  totpDisable: (password: string, code: string) => post<void>("/api/auth/totp/disable", { password, code }),
};
